import { render } from "./Product_list.vue?vue&type=template&id=c33aadcc&scoped=true"
import script from "./Product_list.vue?vue&type=script&lang=js"
export * from "./Product_list.vue?vue&type=script&lang=js"

import "./Product_list.vue?vue&type=style&index=0&id=c33aadcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33aadcc"]])

export default __exports__